import { render, staticRenderFns } from "./lockscreen-2.vue?vue&type=template&id=3d88aa62&"
import script from "./lockscreen-2.vue?vue&type=script&lang=js&"
export * from "./lockscreen-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports